import { L, vocabulary } from '../define.js';
/** D577 slice d: ride-actors-relations. */
export const RIDE_ACTORS_RELATIONS_VOCABULARIES = [
    vocabulary('ride.actor', '@vello/relationships PartyRole; @vello/ride CANCEL_ACTORS; @vello/ride RIDE_RATING_RATER_ROLES; @vello/ride RIDE_ACTOR_KINDS', {
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        desk: L('Balcão', 'Desk', 'Mostrador', 'Banco'),
        ops: L('Operação', 'Operations', 'Operaciones', 'Operazioni'),
        system: L('Sistema', 'System', 'Sistema', 'Sistema'),
    }),
    vocabulary('relationships.block_reason', '@vello/relationships BlockReason', {
        safety: L('Segurança', 'Safety', 'Seguridad', 'Sicurezza'),
        preference: L('Preferência', 'Preference', 'Preferencia', 'Preferenza'),
    }),
    vocabulary('relationships.kind', '@vello/relationships RelationshipKind', {
        favorite: L('Favorito', 'Favorite', 'Favorito', 'Preferito'),
        block: L('Bloqueado', 'Blocked', 'Bloqueado', 'Bloccato'),
    }),
    vocabulary('relationships.pair_outcome', '@vello/relationships PairOutcome', {
        BLOCKED: L('Bloqueado', 'Blocked', 'Bloqueado', 'Bloccato'),
        BOOSTED: L('Priorizado', 'Prioritized', 'Priorizado', 'Prioritizzato'),
        NEUTRAL: L('Neutro', 'Neutral', 'Neutro', 'Neutro'),
    }),
    vocabulary('problem.relationships', '@vello/relationships PairReason', {
        SAFETY_BLOCK: L('Bloqueio por segurança.', 'Blocked for safety.', 'Bloqueo por seguridad.', 'Blocco per sicurezza.'),
        PREFERENCE_BLOCK: L('Bloqueio por preferência.', 'Blocked by preference.', 'Bloqueo por preferencia.', 'Blocco per preferenza.'),
        MUTUAL_FAVORITE: L('Favoritos um do outro.', 'Each other’s favorites.', 'Favoritos el uno del otro.', 'Preferiti l’uno dell’altro.'),
        FAVORITE: L('Favorito de um dos lados.', 'Favorite on one side.', 'Favorito de uno de los lados.', 'Preferito da una delle parti.'),
        NO_RELATIONSHIP: L('Sem relação entre as pessoas.', 'No relationship between the people.', 'Sin relación entre las personas.', 'Nessuna relazione tra le persone.'),
    }, 'message'),
];
//# sourceMappingURL=ride-actors-relations.js.map